import { render, staticRenderFns } from "./customerFeedback.vue?vue&type=template&id=d8f878a0&scoped=true&"
import script from "./customerFeedback.vue?vue&type=script&lang=js&"
export * from "./customerFeedback.vue?vue&type=script&lang=js&"
import style0 from "./customerFeedback.vue?vue&type=style&index=0&id=d8f878a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f878a0",
  null
  
)

export default component.exports